import React, { useContext, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import blogFetch from "../../../axios/config";
import Context from "../../../context/Context";
import { getDayNow } from "../../../utils/DataUtils";
import { InsutryPartsTableHeader } from "../../molecules/IndustryPartsTableHeader";
import { handleSortByValue } from "../../../utils/sort";
import { LoadSpinner } from "../../atoms/LoadSpinner";
import { IndustryPartsCards } from "../../molecules/IndustryPartsTableCards";
import { InstryPartsTableBody } from "../../molecules/IndustryPartsTableBody";
import { Pagination } from "@mui/material";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ExportDataXlsx } from "./template/ExportDataXlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import language from '../../../nls/language.json';
import "./styles.css"
import "../../../styles/Style.css"
import { Impressao } from "./template/Impressao";
import { PictureAsPdf } from "@mui/icons-material";
import { useMemo } from "react";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const IndustryPartsTable = () => {
  const [parts, setParts] = useState([]);
  const [lastUpdate, setLastUpdate] = useState("");

  const [message, setMessage] = useState(null);
  const [filteredItems, setFilteredItems] = useState({
    isFilter: false,
    filterParts: []
  });
  const [page, setPage] = useState(1);
  const [objFilter, setObjFilter] = useState({
    hp: {
      inputValue: "",
      checkbox: []
    },
    ordem_Serial: {
      inputValue: "",
      checkbox: []
    },
    ordem_Part_Cod: {
      inputValue: "",
      checkbox: []
    },
    ordem_DtUltApont: {
      inputValue: "",
      checkbox: []
    },
    ordem_VehCod: {
      inputValue: "",
      checkbox: []
    },
    subProduto_Desc: {
      inputValue: "",
      checkbox: []
    },
    ordem_CodMaterial: {
      inputValue: "",
      checkbox: []
    },
    order: {
      orderByKey: "",
      orderBy: 0
    }
  });

  const {
    selectedValueSector,
    setSelectedValueSector,
    getSector,
    loadingIndustryPartsTable,
    setIndustryPartsTable,
    selectedCountry
  } = useContext(Context);


  useEffect(() => {
    handleSortByValue(parts, objFilter.order.orderByKey, objFilter.order.orderBy)
  }, [objFilter.order.orderBy]);

  useEffect(() => {
    handleFilter()
  }, [objFilter]);

  useEffect(() => {
    getParts(selectedValueSector.stR_description);
  }, [selectedValueSector]);

  const TIME_UPDATE = 60000 * 5;
  let myInterval = null;
  let myIntervalAux = null;

  useEffect(() => {
    const interval = setInterval(() => {
      loopUpdate(selectedValueSector.stR_description);
    }, TIME_UPDATE);

    return () => clearInterval(interval);
  }, [selectedValueSector]);

  const date = new Date(Date.now());
  const getDataFormatada = (pedido_Data) => {
    let partesData = pedido_Data.split(".");
    let dataFormatada = `${partesData[1]}/${partesData[0]}/${partesData[2]}`;
    return new Date(Date.parse(dataFormatada));
  }


  const loopUpdate = (sector) => {
    blogFetch.get('/ISAGA_Pendencias/checkPendingStatus');
    getParts(sector);
  }

  const getParts = async (sector) => {
    try {
      setIndustryPartsTable(true);
      const { data } = await blogFetch.get(`/SAGAViewPecasSetor/${sector}`);

      // if (!data.sagaViewPecasSetor.length) {
      //   console.log(data.sagaViewPecasSetor.length,'length')
      //   const userSector = JSON.parse(localStorage.getItem('user'));
      //   return getParts(userSector?.sector.stR_description)
      // }

      console.log(data.sagaViewPecasSetor);
      setParts(data.sagaViewPecasSetor);
      setLastUpdate(getDayNow());
      GetMessage();
    } catch {
      console.error("Error");
    }
    finally {
      setIndustryPartsTable(false);
    }
  };

  console.log("Parts Setor" + parts.sagaViewPecasSetor)

  const itemsPerPage = 30;
  const offset = (page - 1) * itemsPerPage;

  // Ordenação e filtragem aplicadas a toda a lista
  const sortedData = useMemo(() => {
    // Primeiro, pegamos os dados filtrados (se houver filtro)
    const itemsToSort = filteredItems.isFilter ? filteredItems.filterParts : parts;

    // Ordenamos os dados
    return [...itemsToSort].sort((a, b) => {
      const key = objFilter.order.orderByKey;
      const order = objFilter.order.orderBy; // 1 para ascendente, -1 para descendente

      return order * (a[key] > b[key] ? 1 : -1);
    });
  }, [filteredItems, parts, objFilter.order]);

  // Paginação aplicada após a ordenação
  const paginatedData = useMemo(() => {
    return sortedData.slice(offset, offset + itemsPerPage);
  }, [sortedData, offset, itemsPerPage]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleRefresh = (event, value) => {
    getParts(selectedValueSector.stR_description);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setPage(1)
    setObjFilter((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        inputValue: value
      }
    }));
  };

  const handleSelectValue = ({ target: { name, value } }) => {
    setPage(1)
    setObjFilter((prev) => {
      const current = prev[name]?.selectedValue;
      return {
        ...prev,
        [name]: {
          ...prev[name],
          selectedValue: current === value ? "" : value
        }
      };
    });
  };

  const formatValue = (key, item) => {
    if (!item) return "";
    switch (key) {
      case "ordem_VehCod":
        return `${item.ordem_VehCod ?? ""} - ${item.ordem_VehDesc ?? ""}`;
      case "ordem_Part_Cod":
        return `${item.ordem_Part_Cod ?? ""} - ${item.ordem_Part_Short ?? ""}`;
      case "ordem_Aco":
        return item.ordem_Aco ? "Sim" : "Não";
      case "subProduto_Desc":
        return item.subProduto_Desc?.toUpperCase() ?? "";
      case "gsa_status":
        return item.gsa?.gsA_Status && !item.gsa?.gsA_DataFinalizacao
          ? item.gsa.gsA_Status.toUpperCase()
          : "";
      case "qtdRF":
        return item.qtdRF > 0 ? item.qtdRF : "";
      default:
        return item[key];
    }
  };

  const handleSortClick = (orderByKey) => {
    setObjFilter((prevState) => ({
      ...prevState,
      order: {
        orderByKey,
        orderBy: prevState.order.orderBy === 1 ? -1 : 1
      }
    }));
  };

  const handleFilter = () => {
    const hasActiveFilter = Object.values(objFilter).some(
      (f) => f && (f.inputValue || f.selectedValue)
    );

    if (!hasActiveFilter) {
      setFilteredItems({ isFilter: false, filterParts: [] });
      return;
    }

    const filterItems = parts.filter((item) => {
      return Object.keys(objFilter).every((key) => {
        const filter = objFilter[key];
        if (!filter) return true;
        if (!filter.inputValue && !filter.selectedValue) return true;

        try {
          const itemValue = formatValue(key, item)?.toString().toLowerCase();

          if (filter.selectedValue && itemValue !== filter.selectedValue.toLowerCase()) {
            return false;
          }
          if (filter.inputValue && !itemValue?.includes(filter.inputValue.toLowerCase())) {
            return false;
          }
          return true;
        } catch {
          const raw = item[key]?.toString() ?? "";
          if (filter.selectedValue && raw !== filter.selectedValue) return false;
          if (filter.inputValue && !raw.includes(filter.inputValue)) return false;
          return true;
        }
      });
    });

    setFilteredItems({
      isFilter: true,
      filterParts: filterItems
    });
  };

  const handleFilterCards = (itemParts) => {
    const objItems = {
      isFilter: false,
      filterParts: []
    };

    switch (itemParts) {
      case "pedido_Data":
        objItems.filterParts = parts.filter((item) => getDataFormatada(item.pedido_Data) < date);
        objItems.isFilter = true;
        break;
      case "pend_Key":
        objItems.filterParts = parts.filter((item) => item.pend_Key);
        objItems.isFilter = true;
        break;
      case "gsa":
        objItems.filterParts = parts.filter(item => item.gsa?.gsA_Status && !item.gsa.gsA_DataFinalizacao);
        objItems.isFilter = true;
        break;
      case "total":
        objItems.filterParts = parts.filter(item => item);
        objItems.isFilter = true;
        break;

    }
    setFilteredItems(objItems);
    setPage(1);
  };

  const GetMessage = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_Mensagem/${selectedValueSector.stR_description}`);
      setMessage(data)
    } catch {
      console.error("error")
    }
  }

  const handleChange = (value) => {
    setSelectedValueSector(value);
  };

  const additionalHeaderFields = (sector) => {
    switch (sector) {
      case "01CORTE":
      case "01HIDCOR":
      case "03SERIG":
      case "05EMPOLV":
        return {
          "LOTE CORTE": "lote_Corte",
        };
      case "06CURVAD - Buffer":
        return {
          ACO: "ordem_Aco",
          RACKBUFFER: "rack_Buffer"
        };
      case "06CURVAD - Curvando":
        return {
          ACO: "ordem_Aco",
          RACKBUFFER: "rack_Buffer"
        };
      case "12P_MONT":
        return {
          RACKPC: "rack_PC",
          RACKPU: "rack_PU",
          ACO: "aco_Codigo",
          ACO_STATUS: 'steelStatus',
          COD_ACO: "aco_Codigo"
        };
      case "13PRE_IB":
        return {
          RACKPC: "rack_PC",
          RACKPU: "rack_PU",
          ACO_STATUS: 'steelStatus',
          COD_ACO: "aco_Codigo"
        };
      case "14MONTAG":
        return {
          RACKPC: "rack_PC",
          RACKPU: "rack_PU"
        };
      default:
        return {};
    }
  }

  const tableHeader = (options) => {
    return {
      ...options,
      "HP": "hp",
      "!": "pend_Status",
      "GSA": "gsa_status",
      "OP": "ordem_Serial",
      "QTD RF": "qtdRF",
      "PEÇA": "ordem_Part_Cod",
      "VEICULO": "ordem_VehCod",
      "PRODUTO": "subProduto_Desc",
      "CODMAT": "ordem_CodMaterial",
      "DIAS PLANTA": "lote_DiasNaPlanta",
      ...additionalHeaderFields(selectedValueSector.stR_description)
    }
  };

  const getColor = (cor) => {
    const color = {
      "#000": "PRETA",
      "#e70000": "VERMELHA",
      "#b5b5b5": "BRANCA",
      "#0092ca": "AZUL"
    }

    return color[cor];
  }

  const dataToXlsx = (data) => {
    return data.reduce((acc, curr) => {
      const arr = Object.entries(tableHeader()).reduce((acumulador, [key, value]) => {
        return key != "!" ? {
          ...acumulador,
          "Observação": "",
          [key]: curr[value],
          "COR": getColor(curr.cor_HP),
        } : acumulador
      }, {})

      return [...acc, arr]
    }, [])
  }

  const handlePrint = async (dataOpen) => {
    const classeImpressao = new Impressao(dataToXlsx(dataOpen));
    const documento = await classeImpressao.PreparaDocumento();
    pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
  }

  return (
    <div className="industry-parts-table-container container-fluid">
      {loadingIndustryPartsTable && <LoadSpinner />}

      <marquee className="marquee-html rounded mt-1">
        {message?.map((element) => element.mensagem_Texto + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\*\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0")}
      </marquee>
      <div className="overflow-table">

        {/* <div className="marquee-container rounded">
            {message?.map((element, index) => (
              <span key={index} className="marquee-text">
                {element.mensagem_Texto} &nbsp;*&nbsp;
              </span>
            ))}
          </div> */}

        {/* Cabeçalho da Tabela */}
        <div className="piece-sector-header d-flex flex-column flex-md-row align-items-center justify-content-between p-3 bg-slate-500">
          <span className="text-blue">{lastUpdate}</span>

          <AsyncSelect
            className="async-select"
            required
            cacheOptions
            defaultOptions
            placeholder={selectedValueSector}
            value={selectedValueSector}
            getOptionLabel={(e) => e.stR_description}
            getOptionValue={(e) => e.stR_description}
            loadOptions={getSector}
            onChange={handleChange}
          />

          {selectedValueSector.stR_description === "06CURVAD - Buffer" && (
            <Link to="/wagon">
              <Button className="button-create-wagon">Criar Vagão</Button>
            </Link>
          )}


          {/* {selectedValueSector.stR_description === "14MONTAG" && (
            <Link to="/listaMontagem">
              <Button className="button-create-wagon">Lista Montagem</Button>
            </Link>
          )} */}

          <IndustryPartsCards parts={parts} handleFilterCards={handleFilterCards} />

          <div className="d-flex justify-content-end">
            <ExportDataXlsx
              data={dataToXlsx(paginatedData)}
              fileName={`${selectedValueSector.stR_description}-${getDayNow()}`}
              fontSize="large"
            />
          </div>
        </div>

        {/* Exportação de Dados */}


        {/* Tabela de Peças */}
        {parts.length !== 0 ? (
          <>
            <table className="table table-striped text-center">
              <thead>
                <tr>
                  {Object.entries(tableHeader()).map(([key, value], index) => (
                    <InsutryPartsTableHeader
                      placeholder="Pesquisar..."
                      name={value}
                      key={`InsutryPartsTableHeader-${index}`}
                      handleChanges={handleInputChange}
                      handleSelect={handleSelectValue}
                      handleSortClick={handleSortClick}
                      header={key}
                      items={parts}
                      inputValue={objFilter[value]?.inputValue || ""}
                      selectedValue={objFilter[value]?.selectedValue || ""}
                      formatValue={formatValue}
                    />
                  ))}
                </tr>
              </thead>
              <tbody>
                <InstryPartsTableBody data={paginatedData} />
              </tbody>
            </table>

            {/* Paginação */}
            <Pagination
              count={Math.ceil(
                !filteredItems.isFilter ? parts.length / itemsPerPage : filteredItems.filterParts.length / itemsPerPage
              )}
              page={page}
              onChange={handlePageChange}
            />
          </>
        ) : (
          <div className="no-data-container">
            <h2>Não foram carregadas peças para o setor</h2>
            <Button variant="dark" onClick={handleRefresh}>
              Atualizar lista
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}